import RecordarNotificacion from './RecordarNotificacion';

export default RecordarNotificacion;
